
export const FINTRO = 'Fintro';
export const FORTIS = 'Fortis';

export const getDomain = () => {
    const {href} = window.location;

    if(href.toLowerCase().includes('fintro')) {
        return FINTRO;
    }

    return FORTIS;
}

export const isFintro = () => {
    return getDomain() === FINTRO;
}
